import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import '../../../assets/css/Buyer/aboutus/about.css';
import AppContext from 'context/AppContext';
import axios from 'axios';

const AboutFaqs = (
  
  {
  subtitle = "FAQ",
  title = "Frequently Asked Questions",
  // faqs = {
  //   column1: [
  //     {
  //       question: "What services does Real Nest provide for buyers and sellers?",
  //       answer: "We provide comprehensive real estate services including property listing, valuation, marketing, and negotiation support for both buyers and sellers."
  //     },
  //     {
  //       question: "How can I search for properties on Real Nest?",
  //       answer: "Your leading real estate advocate, transforming houses into dreams. Trust us to expertly guide you home. 745,000 apartments & home for sell, rent & mortgage."
  //     },
  //     {
  //       question: "Does Real Nest charge any fees for its services?",
  //       answer: "We charge a standard commission fee for successful property transactions, transparently discussed before any agreement."
  //     },
  //      {
  //       question: "How do I find a property?",
  //       answer: "Use our advanced search filters to find properties by location, price, type, and amenities."
  //     }
  //   ],
  //   column2: [
  //     {
  //       question: "Can I list my property on Real Nest as an owner?",
  //       answer: "Yes, property owners can list their properties directly on our platform after a simple verification process."
  //     },
  //     {
  //       question: "Do you help with legal papers?",
  //       answer: "Absolutely. We have a dedicated legal team to assist with all necessary documentation and legal procedures."
  //     },
  //     {
  //       question: "How can I schedule a property visit through Real Nest?",
  //       answer: "You can easily schedule a visit through our website or by contacting our agents directly via phone or email."
  //     }
  //   ]
  // }
}) => {
  const[faqs,setFaqs]=useState([]);
  const{baseUrl}=useContext(AppContext);

  const viewAllBuyerFaqs = () => {
    axios
      .post(`${baseUrl}/buyer/buyerfaqs/viewAllBuyerFaqs`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setFaqs(response.data.exfaq || []);
        }
      })
      .catch((error) => {
        console.log(error);

      });
  };
  useEffect(()=>{
    viewAllBuyerFaqs();
  },[]);


  return (
    <section className="faq-section section-padding">
      <Container>
        <div className="text-center mb-5">
          <small className="text-uppercase text-muted fw-bold faq-subtitle">{subtitle}</small>
          <h2 className="section-title fw-bold mt-2 animate-on-scroll">{title}</h2>
        </div>

        <Row>
          {/* Column 1 */}
          <Col md={6} className="mb-4">
            <Accordion  className="faq-accordion">
              {faqs.map((faq, index) => (
                <Accordion.Item 
                  eventKey={index.toString()} 
                  className="mb-3 border-0 shadow-sm faq-item"
                  key={index}
                >
                  <Accordion.Header className="faq-header">
                    {faq.question}
                  </Accordion.Header>
                  <Accordion.Body className="faq-body">
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>

          {/* Column 2 */}
          <Col md={6}>
            <Accordion className="faq-accordion">
              {faqs.map((faq, index) => (
                <Accordion.Item 
                  eventKey={index.toString()} 
                  className="mb-3 border-0 shadow-sm faq-item"
                  key={index}
                >
                  <Accordion.Header className="faq-header">
                    {faq.question}
                  </Accordion.Header>
                  <Accordion.Body className="faq-body">
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutFaqs;